<div class="main-container">
  <nz-breadcrumb>
    <nz-breadcrumb-item>首页</nz-breadcrumb-item>
    <nz-breadcrumb-item>报告打印</nz-breadcrumb-item>
  </nz-breadcrumb>
  <div class="report-box">
    <div class="report-container" id="printContent">
      <div class="header">
        <div class="qr-code">
          <!-- QR Code -->
          <img [src]="qcCodeURL" alt="" />
        </div>
        <div class="title">
          <h1>云起医澜医院</h1>
          <h2>{{ caseDetail.deviceType }}检查报告</h2>
        </div>
      </div>

      <div class="patient-info">
        <nz-row [nzGutter]="16">
          <nz-col nzSpan="6">
            患者姓名：
            <span class="value">{{ caseDetail.patientName }}</span>
          </nz-col>
          <nz-col nzSpan="6">
            患者年龄：
            <span class="value">{{ caseDetail.patientAge }}Y</span>
          </nz-col>
          <nz-col nzSpan="6"
            >患者性别：
            <span class="value">{{ caseDetail.patientGender }}</span>
          </nz-col>
          <nz-col nzSpan="6"
            >患者编号：
            <span class="value">{{ caseDetail.patientId }}</span>
          </nz-col>
        </nz-row>
        <nz-row [nzGutter]="16">
          <nz-col nzSpan="6"
            >检查部位：
            <span class="value">{{ caseDetail.bodyPartExamined }}</span>
          </nz-col>
          <nz-col nzSpan="6"
            >申请科室：
            <span class="value">{{ caseDetail.applyDepartment }}</span>
          </nz-col>
          <nz-col nzSpan="6"
            >检查类型：
            <span class="value">{{ caseDetail.deviceType }}</span>
          </nz-col>
          <nz-col nzSpan="6"
            >床号：
            <span class="value">{{ caseDetail.bedNumber }}</span>
          </nz-col>
        </nz-row>
      </div>

      <div class="description">
        <h3>影像学描述</h3>
        <div class="content">
          <!-- 填写描述内容 -->
          {{ caseDetail.reportDescribe }}
        </div>
      </div>

      <div class="suggestion">
        <h3>影像学建议</h3>
        <div class="content">
          <!-- 填写建议内容 -->
          {{ caseDetail.reportDiagnose }}
        </div>
      </div>

      <div class="footer">
        <nz-row>
          <nz-col nzSpan="8">报告医生：{{ caseDetail.reporter }}</nz-col>
          <nz-col nzSpan="8">审核医生：{{ caseDetail.auditor }}</nz-col>
          <nz-col nzSpan="8">报告时间：{{ caseDetail.reportTime | date : 'yyyy-MM-dd HH:mm:ss' }}</nz-col>
        </nz-row>
      </div>
    </div>
    <div class="report-setting">
      <!-- 上传报告按钮 -->
      <button nz-button nzType="primary" (click)="uploadReportImg()">打印报告</button>
    </div>
  </div>
</div>
